export const getTrialDates = (trialLength: number) => {
  const trialStart = new Date(); // Current date and time

  // Create trialEnd by adding the trialLength to the current time
  const trialEnd = new Date(trialStart);
  trialEnd.setDate(trialEnd.getDate() + trialLength); // Add trialLength days

  // Format the dates to the required string format
  const formatDate = (date: Date) => date.toISOString().slice(0, 19).replace('T', ' ');

  return {
    trialStart: formatDate(trialStart),
    trialEnd: formatDate(trialEnd),
  };
};
